import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";

const Actions = {
  setKyc: "setKyc",
  setNps: "setNps",
  setUser: "setUser",
  updateUser: "updateUser",
  setPartner: "setPartner",
  setCampaign: "setCampaign",
  setBankList: "setBankList",
  setReferral: "setReferral",
  setSubscriptionStatus: "setSubscriptionStatus",
  fetchSummary: "fetchSummary",
  updateAppStorage: "updateAppStorage",
  updateBankList: "updateBankList",
  resetAppData: "resetAppData",
};

//actions
export const setKyc = createAction(Actions.setKyc);
export const setNps = createAction(Actions.setNps);
export const setUser = createAction(Actions.setUser);
export const updateUser = createAction(Actions.updateUser);
export const setPartner = createAction(Actions.setPartner);
export const setCampaign = createAction(Actions.setCampaign);
export const setBankList = createAction(Actions.setBankList);
export const setReferral = createAction(Actions.setReferral);
export const fetchSummary = createAction(Actions.fetchSummary);
export const updateBankList = createAction(Actions.updateBankList);
export const updateAppStorage = createAction(Actions.updateAppStorage);
export const resetAppData = createAction(Actions.resetAppData);
export const setSubscriptionStatus = createAction(
  Actions.setSubscriptionStatus
);

export const getAppData = (state) => {
  return get(state, "app", {});
};

export const getKyc = (state) => {
  return get(state, "app.kyc", {});
};

export const getUser = (state) => {
  return get(state, "app.user", {});
};

export const getCampaign = (state) => {
  return get(state, "app.campaign", []);
};

export const getReferral = (state) => {
  return get(state, "app.referral", {});
};

export const getBankList = (state) => {
  return get(state, "app.bankList", []);
};

export const getPartner = (state) => {
  return get(state, "app.partner", "");
};

export const getNps = (state) => {
  return get(state, "app.nps", {});
};

export const getSubscriptionStatus = (state) => {
  return get(state, "app.subscriptionStatus", {});
};

export const getAppStorage = (state) => {
  return get(state, "app.appStorage", {});
};

// initialState
const initialState = {
  appStorage: {},
  bankList: [],
  nps: {},
  kyc: {},
  user: {},
  partner: "",
  campaign: {},
  referral: {},
  subscriptionStatus: {},
};

//reducer
export default createReducer(initialState, (builder) => {
  builder.addCase(updateAppStorage, (state, action) => {
    state.appStorage = { ...state.appStorage, ...action.payload };
  });
  builder.addCase(setKyc, (state, action) => {
    state.kyc = action.payload;
  });
  builder.addCase(setUser, (state, action) => {
    state.user = action.payload;
  });
  builder.addCase(updateUser, (state, action) => {
    state.user = { ...state.user, ...action.payload };
  });
  builder.addCase(setNps, (state, action) => {
    state.nps = action.payload;
  });
  builder.addCase(setPartner, (state, action) => {
    state.partner = action.payload;
  });
  builder.addCase(setCampaign, (state, action) => {
    state.campaign = action.payload;
  });
  builder.addCase(setBankList, (state, action) => {
    state.bankList = action.payload;
  });
  builder.addCase(setReferral, (state, action) => {
    state.referral = action.payload;
  });
  builder.addCase(setSubscriptionStatus, (state, action) => {
    state.subscriptionStatus = action.payload;
  });
  builder.addCase(resetAppData, () => {
    return initialState;
  });
});
